import { createSelector } from 'reselect';

export const selectAuthState = (state) => state.auth;
export const isLogged = createSelector(selectAuthState, (authState) => authState.data?.active);

export const selectMenuLoadState = (state) => state.menu;
export const selectMenuState = (state) => state.menu.data.menus;
